export const ROUTING = {
  main: '/',
  topupPhone: '/topup-phone',
  topupEnergy: '/topup-energy',
  topupCodes: '/topup-codes'
}
